export const lightThemeRoutes = ['embed'] as const
// Keep uppercase alias for backward compatibility with older imports.
export const LIGHT_THEME_ROUTES = lightThemeRoutes
type LightThemeRoute = (typeof lightThemeRoutes)[number]

const lightThemeRouteSet: ReadonlySet<string> = new Set<LightThemeRoute>(lightThemeRoutes)
/**
 * Normalizes a pathname by:
 * - removing query/hash
 * - trimming
 * - collapsing multiple slashes
 * - ensuring it starts with "/"
 */
const normalizePathname = (pathname: string): string => {
  const base = pathname.split(/[?#]/, 1)[0].trim()
  const collapsed = base.replace(/\/{2,}/g, '/')
  return collapsed.startsWith('/') ? collapsed : `/${collapsed}`
}

export const isLightThemeRoute = (pathname: string, depth = 2): boolean => {
  // We only inspect leading route segments (e.g. "/embed/..." or "/workspace/embed/...").
  const safeDepth = Number.isFinite(depth) ? Math.max(0, Math.trunc(depth)) : 0
  if (safeDepth === 0) return false

  return normalizePathname(pathname)
    .split('/')
    .filter(Boolean)
    .slice(0, safeDepth)
    .some((segment) => lightThemeRouteSet.has(segment))
}
